var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPostLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 7.97502C18.75 13.4451 10.6414 17.8727 10.2961 18.0555C10.2051 18.1045 10.1033 18.1301 10 18.1301C9.89665 18.1301 9.79492 18.1045 9.70391 18.0555C9.35859 17.8727 1.25 13.4451 1.25 7.97502C1.25145 6.69052 1.76223 5.45904 2.6703 4.55076C3.57837 3.64248 4.80955 3.13157 6.09375 3.13013C7.70703 3.13013 9.11953 3.82404 10 4.99697C10.8805 3.82404 12.293 3.13013 13.9062 3.13013C15.1904 3.13157 16.4216 3.64248 17.3297 4.55076C18.2378 5.45904 18.7486 6.69052 18.75 7.97502Z",
    fill: "#FF0031"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostLiked);
export default __webpack_public_path__ + "static/media/icon_post_liked.b9d92985689cbba6625a8da705798a9e.svg";
export { ForwardRef as ReactComponent };